import { render, staticRenderFns } from "./allBonus.vue?vue&type=template&id=3305e0a6"
import script from "./allBonus.vue?vue&type=script&lang=js"
export * from "./allBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports